import React, { useEffect, useState } from "react"
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { Panel, Table } from 'rsuite'
import { getLinkedSuppliersByContactId } from "../../redux/actions/contact"
import LoaderComponent from "../CommonComponents/LoaderComponent"
import { useDispatch } from "react-redux"
import { BiSolidUserDetail } from "react-icons/bi"
import { FaRegCreditCard } from "react-icons/fa"
import { RiBankLine } from "react-icons/ri"
const { Column, HeaderCell, Cell, Pagination } = Table

const LinkedContactSuppliers = ({ contactId = null }) => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const [linkedSuppliers, setLinkedSuppliers] = useState([])
    const [linkedSuppliersInfo, setLinkedSuppliesrInfo] = useState([])
    const [linkedCardAcceptances, setLinkedCardAcceptances] = useState([])
    const [linkedCardAcceptanceEmails, setLinkedCardAcceptanceEmails] = useState([])
    const [linkedPayments, setLinkedPayments] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [sortColumn, setSortColumn] = useState()
    const [sortType, setSortType] = useState()

    useEffect(() => {
        if (contactId) {
            setIsLoading(true)
            dispatch(getLinkedSuppliersByContactId({ contactId })).then(res => {
                setLinkedSuppliers([
                    ...(res?.suppliers?.length > 0 ? res.suppliers : []),
                    ...(res?.listSuppliers?.length > 0 ? res.listSuppliers : [])
                ]);
                setLinkedSuppliesrInfo(res?.linkedSupplierInfo?.length > 0 ? res?.linkedSupplierInfo : [])
                setLinkedCardAcceptances(res?.linkedCardAcceptances?.length > 0 ? res?.linkedCardAcceptances : [])
                setLinkedCardAcceptanceEmails(res?.linkedCardAcceptanceEmails?.length > 0 ? res?.linkedCardAcceptanceEmails : [])
                setLinkedPayments(res?.linkedPayments?.length > 0 ? res?.linkedPayments : [])
                setIsLoading(false)
            }).catch(() => {
                setLinkedSuppliers([])
                setIsLoading(false)
            })
        }
    }, [contactId])

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };

    const paginatedData = linkedSuppliers?.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string') {
            x = x.charCodeAt();
        }
        if (typeof y === 'string') {
            y = y.charCodeAt();
        }
        if (sortType === 'asc') {
            return x - y;
        } else {
            return y - x;
        }
    }).slice(limit * (page - 1), limit * page)

    const panelHeader = (headerText) => {
        return (
            <h4 className={`mb-0`}> {headerText} </h4>
        )
    }

    return (
        <Panel header={panelHeader('All Linked Suppliers')} className={`bg-white mt-0 `} defaultExpanded={false} collapsible bordered>
            <div className={`${isLoading ? ' position-relative loading' : ''}`}>
                {isLoading && <LoaderComponent />}
                <Table
                    height={400}
                    data={paginatedData}
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortColumn}
                >
                    <Column
                        sortable
                        key="suppliername"
                        width={400}
                    >
                        <HeaderCell><h4 className='mb-0 fw-bold text-black'>Supplier Name</h4></HeaderCell>
                        <Cell dataKey='suppliername' className='text-black' >
                            {rowData => {
                                let supplierLink = ''
                                if (rowData?.isMaster && !rowData?.masterId) {
                                    supplierLink = `/suppliers/${rowData?.id}`
                                } else {
                                    supplierLink = `/suppliers/relatedsupplier/${rowData?.id}`
                                }
                                return <Link to={supplierLink} target="_blank" title={rowData?.suppliername ? rowData?.suppliername : ''} className="mb-0 text-primary">{rowData?.suppliername ? rowData?.suppliername : ''}</Link>
                            }}
                        </Cell>
                    </Column>
                    <Column
                        key="supplierType"
                        width={200}
                    >
                        <HeaderCell><h4 className='mb-0 fw-bold text-black'>Supplier Type</h4></HeaderCell>
                        <Cell dataKey='supplierType' className='text-black' >
                            {rowData => {
                                let supplierType = ''
                                if (rowData?.hasOwnProperty('isMaster')) {
                                    if (rowData?.isMaster && !rowData?.masterId) {
                                        supplierType = 'Master'
                                    } else if (rowData?.isMaster && rowData?.masterId) {
                                        supplierType = 'Location Master'
                                    } else if (!rowData?.isMaster) {
                                        supplierType = 'Child'
                                    }
                                } else {
                                    supplierType = 'List Supplier'
                                }
                                return <p title={supplierType ? supplierType : ''} className="mb-0">{supplierType ? supplierType : ''}</p>
                            }}
                        </Cell>
                    </Column>
                    <Column
                        key="linkedInfo"
                        flexGrow={1}
                    >
                        <HeaderCell><h4 className='mb-0 fw-bold text-black'>Linked Info</h4></HeaderCell>
                        <Cell dataKey='linkedInfo'>
                            {rowData => {
                                const isSupplierInfo = linkedSuppliersInfo?.length > 0 ? linkedSuppliersInfo?.find(data => data?.id === rowData?.id) : null
                                const isCardAccInfo = linkedCardAcceptances?.length > 0 ? linkedCardAcceptances?.find(data => data?.supplierId === rowData?.id) : null
                                const isCardAccEmailsInfo = linkedCardAcceptanceEmails?.length > 0 ? linkedCardAcceptanceEmails?.find(data => data?.supplierId === rowData?.id) : null
                                const isPaymentInfo = linkedPayments?.length > 0 ? linkedPayments?.find(data => data?.supplierId === rowData?.id) : null
                                return (
                                    <div className='d-flex gap-4'>
                                        <BiSolidUserDetail title='Linked with supplier info' size={30} color={isSupplierInfo?.id ? '#198754' : '#D9D9D9'} />
                                        <FaRegCreditCard title='Linked with card acceptance' size={30} color={(isCardAccInfo?.supplierId || isCardAccEmailsInfo?.supplierId) ? '#198754' : '#D9D9D9'} />
                                        <RiBankLine title='Linked with payment info' size={30} color={isPaymentInfo ? '#198754' : '#D9D9D9'} />
                                    </div>
                                )
                            }}
                        </Cell>
                    </Column>
                </Table>
                <div className="child-vendor-table-pagination">
                    <Pagination
                        prev
                        next
                        first
                        last
                        maxButtons={5}
                        activePage={page}
                        showInfo
                        layout={['limit', '|', 'pager']}
                        displayLength={limit}
                        total={linkedSuppliers?.length || 0}
                        lengthMenu={[
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '20',
                                value: 20,
                            },
                            {
                                label: '30',
                                value: 30,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                            {
                                label: '100',
                                value: 100,
                            },
                        ]}
                        onChangePage={(event) => { setPage(event) }}
                        onChangeLength={handleChangeLimit}
                    />
                </div>
            </div>
        </Panel>
    )
}

export default LinkedContactSuppliers